import React, { Component } from "react";
import ViewNotice from "./ViewNotice";
import AddNotice from "./AddNotice";
import setTitle from "../../../helpers/TitleComponent";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { isEmpty } from "../../../helpers";
// import { Button } from "reactstrap";
const axios = require("axios");
export default class PublishNotice extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      form: {
        clientId: null,
        noticeBody: null,
        startDate: null,
        endDate: null,
        createdBy: getCookie("username"),
        enabled: true,
        displayArea: "",
      },
      enabled: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" },
      ],
      clients: [],
      rules: {
        clientId: ["required"],
        noticeBody: ["required"],
        startDate: ["required"],
        endDate: ["required"],
        displayArea: ["required"],
      },
      operation: "Add",
      selected: {},
      permissions: [],
    };
  }

  formClear() {
    let form = {
      clientId: null,
      noticeBody: null,
      startDate: null,
      endDate: null,
      createdBy: getCookie("username"),
      enabled: true,
      displayArea: "",
    };
    this.setState(
      {
        form: form,
        operation: "Add",
      },
      function () {
        this.childRef.current.validate((errors) => { });
      }
    );
  }

  async getClientsForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allclientinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              clients: response.data.object,
            });
          }
        })
        .catch(function (error) { });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }
  componentDidMount() {
    var data = getCookie("permission");
    this.setState(
      {
        permissions: JSON.parse(data),
      },
      () => {
        setTitle("Publish Notice");
        this.getClientsForComboBox();
      }
    );
  }

  OnEditClick() {
    if (this.state.selected != null) {
      var editdata = {
        clientId: this.state.selected.clientId,
        startDate: new Date(this.state.selected.startDate),
        endDate: new Date(this.state.selected.endDate),
        noticeBody: this.state.selected.noticeBody,
        displayArea: this.state.selected.displayArea,
        createdBy: this.state.selected.createdBy,
        id: this.state.selected.id,
        enabled: true,
      };
      this.setState(
        {
          form: editdata,
          operation: "Update",
        },
        function () {
          this.childRef.current.validate((errors) => { });
        }
      );
    }
  }
  onSelectionChange(selectedRow) {
    this.setState({
      selected: selectedRow,
    });
  }
  handleChange(name, value) {
    let form = Object.assign({}, this.state.form);
    form[name] = value;
    this.setState({ form: form });
    //console.log(this.state);
  }
  render() {
    var permissions = this.state.permissions;
    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("publish-notice-create") ? (
            <div className='col-5 '>
              <AddNotice
                formFields={this.state.form}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                clients={this.state.clients}
                formClear={this.formClear}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("publish-notice-view") ? (
            <div className='col-7 '>
              <ViewNotice
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                clients={this.state.clients}
                permissions={permissions}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
